import React from "react";
import { Link } from "react-scroll";

export default () => {
  return (
    <div>
      <div className="navbar navbar-active">
        <div></div>
        <ul>
          <Link
            activeClass="active"
            to="home"
            spy={true}
            smooth={true}
            offset={0}
            duration={750}
          >
            Home
          </Link>

          <Link
            activeClass="active"
            to="about"
            spy={true}
            smooth={true}
            offset={0}
            duration={750}
          >
            About
          </Link>
          <Link
            activeClass="active"
            to="skills"
            spy={true}
            smooth={true}
            offset={0}
            duration={750}
          >
            Skills
          </Link>
          <Link
            activeClass="active"
            to="education"
            spy={true}
            smooth={true}
            offset={0}
            duration={750}
          >
            Education
          </Link>
          <Link
            activeClass="active"
            to="experience"
            spy={true}
            smooth={true}
            offset={0}
            duration={750}
          >
            Experience
          </Link>
          {/* <Link
            activeClass="active"
            to="contact"
            spy={true}
            smooth={true}
            offset={0}
            duration={750}
          >
            Contact
          </Link> */}
        </ul>
      </div>
    </div>
  );
};
